module.exports = __webpack_public_path__ + "media/images/header-8010d6c3.png";